import React from 'react';
import {Container} from 'reactstrap';

class Register extends React.Component {
    render() {
        return (
            <Container className="pt-4 mt-5">
                <div>Sorry, this page does not exist! Make sure you have used the correct link.</div>
            </Container>
        );
    }
}

export default Register;
